var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusSuccessRound = function SvgStatusSuccessRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#6BC7A1",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2DBA6E",
    strokeWidth: 1.5,
    d: "m6.666 12 4 4 8-8.666"
  })));
};
export { SvgStatusSuccessRound as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSIxMiIgY3k9IjEyIiByPSIxMiIgZmlsbD0iIzZCQzdBMSIvPgo8cGF0aCBkPSJNNi42NjYwMiAxMi4wMDAyTDEwLjY2NiAxNi4wMDAyTDE4LjY2NiA3LjMzMzUiIHN0cm9rZT0iIzJEQkE2RSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg==";